import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Loader from "../../UI/loader";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { getDefaultAnalyticsLabel, toBool } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import { DayPicker } from "react-day-picker";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import { popupOpenClose } from "../../../action/action";
import { scrollToTop } from "../../../JS/scrollToTop";


const ResReservationV2_2a = (props) => {

    const { t } = props


    const [guestCount, setGuestCount] = useState(null);

    // below code is for rendering date:
    let dateInputCss = `
    .rdp-day_selected {
        color: ${props.menuColor.assetFontSelectorColor};
        background-color: ${props.menuColor.assetBackgroundSelectorColor};
    }`;
    const [renderDateInput, setRenderDateInput] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [inputDateFormat, setInputDateFormat] = useState("");


    const handlePreCheckInSelectedDate = (selectedDate) => {

        if (!selectedDate) {
            setSelectedDate("")
            setInputDateFormat("");
        } else {

            // converting to local date string
            const year = selectedDate.getFullYear();
            const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
            const day = String(selectedDate.getDate()).padStart(2, '0');

            const localDateString = `${year}-${month}-${day}`;
            setSelectedDate(localDateString)
            setInputDateFormat(dateFormatHandler(new Date(localDateString).toISOString(), props.dateFormat));

            setRenderDateInput(false);
        }

    }

    // below code is for start time
    const selectStartItemsRef = React.useRef(null);
    const [startTime, setStartTime] = React.useState("");
    const [customStartTimeSelect, setCustomStartTimeSelect] = React.useState(false);

    const selectEndItemsRef = React.useRef(null);
    const [endTime, setEndTime] = React.useState("");
    const [customEndTimeSelect, setCustomEndTimeSelect] = React.useState(false);

    const [etaTimeList, setETATimeList] = React.useState([]);

    const formatEstimateCheckInTime = (time, timeFormat12hrs) => {

        if (!time) {
            return "";
        }

        const [hours, minutes] = time.split(":");

        if (timeFormat12hrs) {
            let period = "AM";
            let hour = parseInt(hours, 10);

            if (hour >= 12) {
                period = "PM";
                if (hour > 12) {
                    hour -= 12;
                }
            }

            return `${hour}:${minutes} ${period}`;
        } else {
            return `${hours}:${minutes}`;
        }
    }

    const generateTimeOptions = () => {
        const options = [];
        for (let hours = 0; hours < 24; hours++) {
            for (let minutes = 0; minutes < 60; minutes += 30) {
                const hourString = String(hours).padStart(2, '0');
                const minuteString = String(minutes).padStart(2, '0');
                const timeValue = `${hourString}:${minuteString}`;
                const formatedTimeValue = timeValue;
                options.push(formatedTimeValue);
            }
        }
        setETATimeList(options);
    };

    const handleTimeScroll = () => {
        if (selectStartItemsRef.current) {
            const itemHeight = 45;
            const selectedItemIndex = etaTimeList.indexOf(startTime);
            selectStartItemsRef.current.scrollTop = selectedItemIndex * itemHeight;
        }

        if (selectEndItemsRef.current) {
            const itemHeight = 45;
            const selectedItemIndex = etaTimeList.indexOf(endTime);
            selectEndItemsRef.current.scrollTop = selectedItemIndex * itemHeight;
        }
    };

    React.useEffect(() => {
        if (customStartTimeSelect || customEndTimeSelect) handleTimeScroll();
    }, [customStartTimeSelect, customEndTimeSelect])

    // end



    const handleBack = () => {
        props.goBack();
    }

    const handleNext = () => {

        if(selectedDate == ""){
            props.popupOpenClose(true, t('resReservationV2.select_preferred_date'))
            return;
        }

        if(!guestCount || guestCount == 0){
            props.popupOpenClose(true, t('resReservationV2.select_guest_count'))
            return;
        }


        let preferredVenueDetailsPayload = {
            "date": selectedDate,
            "guestCount": guestCount,
            "startTime": startTime,
            "endTime": endTime,
        }

        props.next(preferredVenueDetailsPayload);
    }


    const updateDataFromProps = () => {
        setStartTime(props.preferredVenueDetails.startTime);
        setEndTime(props.preferredVenueDetails.endTime);
        setGuestCount(+props.preferredVenueDetails.guestCount || null);
        handlePreCheckInSelectedDate( props.preferredVenueDetails.date ? new Date(props.preferredVenueDetails.date) : "")
    }

    useEffect(() => {
        generateTimeOptions();
        updateDataFromProps();
    }, [])


    return (
        <section class="widgets spa-listing spa-details">

            <div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl &&
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }
                <div class="widget-header-title">{props.selectedVenueData.name}</div>
                <div>{t(`resReservationV2.heading2a`)}</div>
            </div>

            <div class="widgets">
                <div class="row margin-bottom-2">
                    <div class="row">
                        <div class="col">
                            <div class="detail-body stay-body">
                                <form>
                                    <div class="form-row">
                                        <p class="heading">{t('resReservationV2.preferred_date')} <span style={{ color: "red" }}>*</span></p>
                                        <input type="button" value={(props.dateFormat && props.dateFormat != null) ? inputDateFormat || t('resReservationV2.select_date_placeholder') : selectedDate || t('resReservationV2.select_date_placeholder')} onClick={() => setRenderDateInput(!renderDateInput)} />
                                    </div>

                                    <div class="form-row">
										<p class="heading">{t('resReservationV2.guest_count')} <span style={{ color: "red" }}>*</span></p>
										<div class="qty-input">
                                            <input type="number" placeholder={t('resReservationV2.guest_count_placeholder')} name="guestCount" value={guestCount} onChange={(e) => setGuestCount(+e.target.value)} />
											<button onClick={(e) => { e.preventDefault(); setGuestCount(+guestCount + 1)}}>+</button>
											<button disabled={guestCount <= 0 ? true : false} onClick={(e) =>{ e.preventDefault(); setGuestCount(+guestCount - 1)}} >-</button>
										</div>
									</div>

                                    <div class="form-row table-start-time">
                                        <p class="heading">{t('resReservationV2.preferred_start_time')}</p>

                                        <div class={`custom-select`} >
                                            <div className="select-selected" onClick={() => setCustomStartTimeSelect(!customStartTimeSelect)} >{startTime ? formatEstimateCheckInTime(startTime, toBool(props.timeFormat)) : t('resReservationV2.select_start_time_placeholder')}</div>
                                            <div className="select-items" ref={selectStartItemsRef || selectEndItemsRef}>
                                                {customStartTimeSelect &&
                                                    etaTimeList.map((time, index) => {
                                                        return (
                                                            <div onClick={(e) => { setStartTime(time); setCustomStartTimeSelect(!customStartTimeSelect) }} key={index} > {formatEstimateCheckInTime(time, toBool(props.timeFormat))} </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>


                                    <div class="form-row table-end-time">
                                        <p class="heading">{t('resReservationV2.preferred_end_time')}</p>

                                        <div class={`custom-select`} >
                                            <div className="select-selected" onClick={() => setCustomEndTimeSelect(!customEndTimeSelect)} >{endTime ? formatEstimateCheckInTime(endTime, toBool(props.timeFormat)) : t('resReservationV2.select_end_time_placeholder')}</div>
                                            <div className="select-items" ref={selectEndItemsRef || selectStartItemsRef}>
                                                {customEndTimeSelect &&
                                                    etaTimeList.map((time, index) => {
                                                        return (
                                                            <div onClick={(e) => { setEndTime(time); setCustomEndTimeSelect(!customEndTimeSelect) }} key={index} > {formatEstimateCheckInTime(time, toBool(props.timeFormat))} </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-controls">
                            <button onClick={handleNext}>{t('resReservationV2.next')}</button>
                            <button onClick={handleBack}>{t('resReservationV2.back')}</button>
                        </div>
                    </div>
                </div>
            </div>


            {renderDateInput &&
                <div className="overlay" onClick={() => setRenderDateInput(!renderDateInput)}>
                    <div onClick={(event) => { event.stopPropagation() }} class="overlay-date">
                        <style>{dateInputCss}</style>
                        <DayPicker
                            mode="single"
                            selected={new Date(selectedDate)}
                            onSelect={(selectedDate) => handlePreCheckInSelectedDate(selectedDate)}
                            disabled={{
                                before: new Date(props.serverTimeDate.split("T")[0])
                            }}
                        />
                    </div>
                </div>
            }

        </section>
    )

}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        serverTimeDate: state.store.home.serverTimeDate.date,
        menuColor: state.store.home.MenuColor,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { closeOrderPopUp, sendAnalytics, popupOpenClose })(withTranslation('translations')(ResReservationV2_2a));